import { Controller } from "@hotwired/stimulus"

// Closes the modal on backdrop click, close button, or Escape.
// With a back-url value it navigates there; otherwise it just empties
// the "modal" turbo frame.
export default class extends Controller {
  static targets = ["modal"]
  static values = { backUrl: String }

  close() {
    if (this.backUrlValue) {
      Turbo.visit(this.backUrlValue)
      return
    }
    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.removeAttribute("src")
      frame.innerHTML = ""
    } else {
      this.element.remove()
    }
  }

  handleShortcut(event) {
    if (event.key === "Escape") this.close()
  }
}
